// TODO: connect external client logging service here (e.g. Sentry SDK)
/* eslint no-console: "off" */
export const log = console.log
